export interface AiInferenceImageDataSourceItem {
  id: AiInferenceImageDataSource;
  names: Record<string, string>;
}

export enum AiInferenceImageDataSource {
  Satellite = 1,
  Uav = 2
}

export const AI_INFERENCE_IMAGE_DATA_SOURCE_USES: AiInferenceImageDataSourceItem[] = [
  {
    id: AiInferenceImageDataSource.Satellite,
    names: {
      'en-US': 'Satellite',
      'ru-RU': 'Спутник',
      'uz-Latn-UZ': "Sun'iy yo'ldosh",
    }
  },
  {
    id: AiInferenceImageDataSource.Uav,
    names: {
      'en-US': 'UAV',
      'ru-RU': 'БПЛА',
      'uz-Latn-UZ': 'BPLA',
    }
  }
];
